import React, { useState } from "react";
import HomeHero from "./homeHero";
import Footer from "../../components/footer";
import HomeHeader from "./components/homeHeader";
import BlogSectionClient from "./components/blogSection";
import "./homePage.css";
import ClientLoginPopup from "./components/clientLoginPopup"; // Import the login popup component
import TopCategories from "./topCategories";
import LegalServices from "./legalServices";
import LawyerCTA from "./lawyerCTA";
import HomeCarouselSection from "./homeCarouselSection";
import ChatContainer from "../chat/chatContainer";
import DownloadImage from "./assets/downloadSection.png";
import DownloadPhone from "./assets/downloadPhone.png";

const HomePage = () => {
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  // Open Login Popup function
  const openLoginPopup = () => setShowLoginPopup(true);

  // Close Login Popup function
  const closeLoginPopup = () => setShowLoginPopup(false);

  return (
    <div>
      {/* Pass the openLoginPopup function to HomeHeader */}
      <HomeHeader
        openLoginPopup={openLoginPopup}
        title=""
        isTitle={false}
        navItems={true}
      />
      <HomeHero />
      <TopCategories />
      <HomeCarouselSection />
      <LegalServices />
      <BlogSectionClient />
      <div className="downloadSection">
        <div className="download-mobile-card">
          <h2 className="download-mobile-title">
            Access Legal Help Anytime, Anywhere
          </h2>
          <p className="download-mobile-description">
            Download the QuidPro app to connect with attorneys on the go, manage
            appointments, and get instant legal guidance.
          </p>

          <div className="download-mobile-buttons">
            <button className="download-mobile-button">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.09997 22C7.78997 22.05 6.79997 20.68 5.95997 19.47C4.24997 17 2.93997 12.45 4.69997 9.39C5.56997 7.87 7.12997 6.91 8.81997 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z"
                  fill="currentColor"
                />
              </svg>
              <div className="button-text">
                <span className="button-small-text">Download on the</span>
                <span className="button-large-text">App Store</span>
              </div>
            </button>

            <button className="download-mobile-button">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.609 1.814L13.792 12L3.61 22.186C3.248 21.863 3 21.359 3 20.765V3.235C3 2.64 3.248 2.137 3.609 1.814V1.814Z"
                  fill="currentColor"
                />
                <path
                  d="M14.5 12.707L4.316 22.89C4.5 22.967 4.697 23 4.906 23C5.279 23 5.664 22.885 6.014 22.654L17.813 16.053L14.5 12.707V12.707Z"
                  fill="currentColor"
                />
                <path
                  d="M20.485 10.595L17.813 9.053L14.5 12.367L17.813 15.68L20.485 14.138C21.171 13.748 21.586 13.124 21.586 12.367C21.586 11.609 21.171 10.985 20.485 10.595Z"
                  fill="currentColor"
                />
                <path
                  d="M4.316 1.11L14.5 11.293L17.813 7.947L6.014 1.346C5.664 1.115 5.279 1 4.906 1C4.697 1 4.5 1.033 4.316 1.11V1.11Z"
                  fill="currentColor"
                />
              </svg>
              <div className="button-text">
                <span className="button-small-text">GET IT ON</span>
                <span className="button-large-text">Google Play</span>
              </div>
            </button>
          </div>

          <div className="download-mobile-image-wrapper">
            <img
              src={DownloadPhone}
              alt="Download App"
              className="download-mobile-image"
            />
          </div>
        </div>
      </div>
      <LawyerCTA />

      <Footer />

      {/* Conditionally render the ClientLoginPopup if showLoginPopup is true */}
      {showLoginPopup && (
        <ClientLoginPopup show={showLoginPopup} onClose={closeLoginPopup} />
      )}
      <ChatContainer />
    </div>
  );
};

export default HomePage;
